import { GameType as GameTypeEnum } from '@/models/games/enums/GameType';
import {
    ROUTE_FAVORITE,
    ROUTE_FEATURED,
    ROUTE_GAME,
    ROUTE_LOBBY,
    ROUTE_MULTIBET,
} from '@/models/Route';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// LOBBY GAME TYPE FILTER
const GAME_CODE_SUFFIXES = [
    { code: -1, suffix: 'all-games' },
    { code: 1, suffix: 'baccarat' },
    { code: 2097168, suffix: 'roulette' },
    { code: 1572868, suffix: 'dice' },
    { code: 2, suffix: 'dragontiger' },
    { code: 512, suffix: 'backjack' },
    { code: 1074003968, suffix: 'gameshow' },
    { code: 16384, suffix: 'pokdeng' },
    { code: 131072, suffix: 'xocdia' },
    { code: 98304, suffix: 'poker' },
];

export const getGAGameCodeSuffix = (gameCode: number) => {
    return GAME_CODE_SUFFIXES.filter(game => game.code == gameCode).map(
        game => game.suffix
    );
};

export const getGAVideoSuffix = (
    currentResolution: string,
    nextResolution: string
) => {
    return `${currentResolution}-to-${nextResolution}`.toLowerCase();
};

const SETTING_GA_KEYS = [
    { key: 'menu.bet_record', gaKey: 'btn_set_bet-rec' },
    { key: 'menu.gift_record', gaKey: 'btn_set_gift-rec' },
    { key: 'menu.game_rules', gaKey: 'btn_set_game-rules' },
    { key: 'menu.language', gaKey: 'btn_set_language' },
    { key: 'menu.sound', gaKey: 'btn_set_sound' },
    { key: 'menu.feedback', gaKey: 'btn_set_feedback' },
];

export const getGASetting = (langKey: string): string | undefined => {
    const entry = SETTING_GA_KEYS.find(k => k.key === langKey);
    return entry?.gaKey;
};

export const useGA = () => {
    const location = useLocation();

    const [page, setPage] = useState<string>('');

    const setPageByGameType = (gameType: number) => {
        switch (gameType) {
            case GameTypeEnum.Baccarat:
                setPage('btn_bac');
                break;
            case GameTypeEnum.Roulette:
                setPage('btn_rou');
                break;
            case GameTypeEnum.UltraRoulette:
                setPage('btn_ult-rou');
                break;
            case GameTypeEnum.SicBo:
                setPage('btn_sic');
                break;
            case GameTypeEnum.Dragon:
                setPage('btn_drag');
                break;
            case GameTypeEnum.PokDeng:
                setPage('btn_pok');
                break;
            case GameTypeEnum.ThaiHiLo:
                setPage('btn_thl');
                break;
            case GameTypeEnum.FishPrawnCrab:
                setPage('btn_fpc');
                break;
            case GameTypeEnum.SeDie:
                setPage('btn_xoc');
                break;
            case GameTypeEnum.TeenPatti2020:
                setPage('btn_tp20');
                break;
            case GameTypeEnum.AndarBahar:
                setPage('btn_andar');
                break;
            case GameTypeEnum.Blackjack:
            case GameTypeEnum.Blackjack2:
                setPage('btn_black');
                break;
            case GameTypeEnum.CarnivalTreasure:
                setPage('btn_ct');
                break;
            default:
                setPage('');
                break;
        }
    };

    useEffect(() => {
        switch (location.pathname) {
            case ROUTE_FEATURED:
                setPage('btn_feat');
                break;
            case ROUTE_FAVORITE:
                setPage('btn_fav');
                break;
            case ROUTE_LOBBY:
                setPage('btn_lob');
                break;
            case ROUTE_MULTIBET:
                setPage('btn_mul');
                break;
            default:
                if (location.pathname.indexOf(ROUTE_GAME) < 0) {
                    setPage('');
                }
                break;
        }
    }, [location.pathname]);

    return { page, setPage, setPageByGameType };
};
export type useGaContextState = ReturnType<typeof useGA>;
